import { createContext, useContext, useEffect, useState } from "react";
import { getDataWAuth } from "../services/api-service";
import { ROUTE_AUTH_ERROR, USER_API_URL } from "../constants/constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const UserContext = createContext();

export const UserInfoProvider = (props) => {
  const [userData, setUserData] = useState({});
  const history = useHistory();

useEffect(() => {
  getDataWAuth(USER_API_URL)
    .then(res => {
      if (res.data && res.data.authorities.length > 0 ) {
        setUserData(res.data);
      } else {
        history.push(ROUTE_AUTH_ERROR);
      }
    })
    .catch(e => {
      console.log(e);
    });
}, []);


  return (
    <UserContext.Provider value={{ userData }}>
      {props.children}
    </UserContext.Provider>
  );
};

export const withUserInfo = (Component) => {
  return function withUserInfo(props) {
    return (
      <UserContext.Consumer>
        {({ userData }) => <Component {...props} userData={userData} />}
      </UserContext.Consumer>
    );
  };
};

export const useUserInfo = () => useContext(UserContext);
